@if (mediaId && imageUrl) {
  <img [attr.src]="imageUrl"
       [alt]="alt"
       [style.max-height]="maxHeight"
       [style.max-width]="maxWidth">
}
